import Loader from '@/commons/loader';
import { useOrder } from '@/hooks/useOrder';
import { useFetch } from '@/modules/orders/hooks/useFetch';
import { changeTipsFactureService, getFactureIdService } from '@/services';
import { errorFacture } from '@/utils/errors';
import { useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import PopTips from '../change-tips';

interface SimpleDialogProps {
  open: boolean;
  value: string;
  onClose: (value: string) => void;
}

export function DialogChangeTips(props: SimpleDialogProps) {
  const { onClose, value, open } = props;
  const queryClient = useQueryClient();
  const { refetch: refetchOrders } = useOrder({});
  const { enqueueSnackbar } = useSnackbar();
  const handleClose = () => {
    onClose(value);
  };
  const {fetchId} = useFetch({fetchFunction : changeTipsFactureService})


  const handleChangeTips = async () => {
    try {
        await fetchId(value)
        refetchOrders();
        enqueueSnackbar('Se cambio propina con exito!');
        handleClose();
    } catch (error) {
      const newMessage = errorFacture[error.message ?? ''];
      if (newMessage) {
        enqueueSnackbar(newMessage, { variant: 'error' });
      } else {
        enqueueSnackbar('Problemas cambiando propina', { variant: 'error' });
      }
    }



  }
const {isLoading, data, fetchId : fetchFactureId,setData} = useFetch({fetchFunction: getFactureIdService})

  const handleFactureId = async () => {

    try {
      const resolve = await fetchFactureId(value)
      setData({
        ...resolve,
        service: {
          tips: resolve?.tips ?? 0,
        },
      })
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:59 ~ handleFactureId ~ error:", error)
      
    }


  }

  useEffect(() => {
    handleFactureId()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (isLoading) {
    return <Loader />;
  }

  return <PopTips current={data?.service ?? {}} onSave={handleChangeTips} />;
}
